export const Bindings = (props) => {
  const articles = props.articulos;
  const bindData = props.bindingsJson;
  const showYears = props.showYears;
  const modelCode = props.modelCode;
  const lang = props.lang;
  // AÑOS
  const AllYearsES = "AÑOS";
  const AllYearsCA = "ANYS";
  const AllYearsEN = "YEARS";
  const AllYearsFR = "ANNÉES";
  const AllYearsIT = "ANNI";
  // AÑO
  const YearES = "AÑO";
  const YearCA = "ANY";
  const YearEN = "YEAR";
  const YearFR = "ANNÉE";
  const YearIT = "ANNO";

  let currentAllYearsValue = "";
  let currentYearValue = "";

  if (lang === "es") {
    currentAllYearsValue = AllYearsES;
    currentYearValue = YearES;
  } else if (lang === "ca") {
    currentAllYearsValue = AllYearsCA;
    currentYearValue = YearCA;
  } else if (lang === "it") {
    currentAllYearsValue = AllYearsIT;
    currentYearValue = YearIT;
  } else if (lang === "fr") {
    currentAllYearsValue = AllYearsFR;
    currentYearValue = YearFR;
  } else {
    currentAllYearsValue = AllYearsEN;
    currentYearValue = YearEN;
  }
  const sortProductsByOrder = (products) => {
    return products.sort((a, b) => {
      if (a.menu_order === null || a.menu_order === undefined) {
        return 1;
      }
      if (b.menu_order === null || b.menu_order === undefined) {
        return -1;
      }
      return a.menu_order - b.menu_order;
    });
  };

  sortProductsByOrder(articles);

  const getBindingYears = (article) => {
    const years = [
      ...new Set(
        bindData
          .filter(
            (bind) =>
              bind.Fijacion_Modelo === modelCode &&
              bind.Fijacion === article.sku &&
              !bind.Fijacion.startsWith("REF_")
          )
          .map((bind) => bind.Fijacion_Anyo)
      ),
    ].sort((a, b) => b - a);

    return (
      <div>
        <div className="product-item-year">
          {years.length === 1 ? currentYearValue : currentAllYearsValue}
        </div>
        <div className="product-item-yearNumber">
          {years.reverse().join(",")}
        </div>
      </div>
    );
  };

  // Recuperar la cookie "region", si el valor es Europe, escondemos el precio
  let cookieValue = document.cookie.replace(
    /(?:(?:^|.*;\s*)region\s*\=\s*([^;]*).*$)|^.*$/,
    "$1"
  );

  return (
    <div className="fijaciones-block">
      <div className="fijaciones-block-group">
        {articles.length === 0 && <p>No hay fijaciones</p>}

        {articles
          .filter((item, pos) => {
            return (
              articles.indexOf(articles.find((x) => x.id === item.id)) === pos
            );
          })
          .map((articulo) => {
            if (articulo !== undefined) {
              return (
                <div
                  className="product-item product-fijacion"
                  key={articulo.id}
                >
                  <a
                    href={articulo?.permalink}
                    rel="noreferrer"
                    target="_blank"
                  >
                    <div className="img-wrapper">
                      {articulo.images && (
                        <img
                          className="product-item-image"
                          src={articulo.images[0].src}
                          alt={articulo.title}
                        />
                      )}
                      <div className="overlay"></div>
                    </div>
                  </a>
                  <div className="product-item-title">{articulo.title}</div>
                  <div className="product-item-sku">{articulo.sku}</div>
                  {cookieValue === "euros" && (
                    <div className="product-item-price">
                      {parseFloat(articulo.price).toFixed(2)}€
                    </div>
                  )}
                  {showYears ? getBindingYears(articulo) : null}
                </div>
              );
            }
            return <></>;
          })}
      </div>
    </div>
  );
};
